module.exports = __webpack_public_path__ + "img/electronic_electric_no_zone.d527c35f.svg";